import React from 'react'
import { useSelector } from 'react-redux'
import { Title, Notification } from '@offerzen/pinata'

import { CandidateState } from '@/CandidateExperience/helpers/constants'
import { isCandidateInState } from '@/CandidateExperience/helpers/candidateHelpers'
import { getCurrentCandidate } from '@/CandidateExperience/selectors/candidate'

import JobList from './JobList'
import styles from './styles'

const RecommendedJobsList = () => {
  const currentCandidate = useSelector(getCurrentCandidate)

  return (
    <div className={styles.recommendedList}>
      <Choose>
        <When condition={isCandidateInState(currentCandidate.current_state, CandidateState.Live)}>
          <div className={styles.heading}>
            <Title className={styles.title}>Jobs you might be interested in</Title>
            <p className={styles.text}>Sorted by relevance</p>
          </div>
        </When>
        <Otherwise>
          <Notification className={styles.notification}>
            <div role="alert">You can view and apply to jobs when your profile is visible to companies.</div>
          </Notification>
        </Otherwise>
      </Choose>

      <JobList candidateProfileId={currentCandidate.id} />
    </div>
  )
}

export default RecommendedJobsList
